<div class="container-fluid">
<section>
    <header>
        <h1><span jhiTranslate="germplasm-manager.title">Manage Germplasm</span><jhi-help-link [helpLink]="helpLink"></jhi-help-link></h1>
    </header>
	<div class="row">
        <section [ngClass]="listBuilderContext.visible ? 'col-7' : 'col'">
            <nav>
                <ul class="nav nav-tabs">
                    <li class="nav-item pe-1">
                        <a class="nav-link" [routerLink]="['germplasm-search']"
                           [routerLinkActive]="['active']"><span jhiTranslate="germplasm-manager.search">Germplasm Search</span></a>
                    </li>
                </ul>
            </nav>
            <div class="tab-content p-3">
                <router-outlet></router-outlet>
            </div>
        </section>
        <section [hidden]="!listBuilderContext.visible" class="col-5 h-auto">
            <jhi-list-builder></jhi-list-builder>
        </section>
    </div>
</section>
</div>
